import createIcon from '../../createIcon';

/**
 * @component @name ThumbDownAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgM0gyMEMxOS40NSAzIDE5IDMuNDUgMTkgNFYxM0MxOSAxMy41NSAxOS40NSAxNCAyMCAxNEgyMlYzWk0yLjE3IDEwLjEyQzIuMDYgMTAuMzcgMiAxMC42NCAyIDEwLjkyVjEyQzIgMTMuMSAyLjkgMTQgNCAxNEg5LjVMOC41OCAxOC42NUM4LjUzIDE4Ljg3IDguNTYgMTkuMTEgOC42NiAxOS4zMUM4Ljg5IDE5Ljc2IDkuMTggMjAuMTcgOS41NCAyMC41M0wxMCAyMUwxNi40MSAxNC41OUMxNi43OSAxNC4yMSAxNyAxMy43IDE3IDEzLjE3VjUuMzRDMTcgNC4wNSAxNS45NSAzIDE0LjY2IDNINi41NkM1Ljg1IDMgNS4yIDMuMzcgNC44NCAzLjk3TDIuMTcgMTAuMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ThumbDownAlt = createIcon('ThumbDownAlt', [
  [
    'path',
    {
      d: 'M22 3H20C19.45 3 19 3.45 19 4V13C19 13.55 19.45 14 20 14H22V3ZM2.17 10.12C2.06 10.37 2 10.64 2 10.92V12C2 13.1 2.9 14 4 14H9.5L8.58 18.65C8.53 18.87 8.56 19.11 8.66 19.31C8.89 19.76 9.18 20.17 9.54 20.53L10 21L16.41 14.59C16.79 14.21 17 13.7 17 13.17V5.34C17 4.05 15.95 3 14.66 3H6.56C5.85 3 5.2 3.37 4.84 3.97L2.17 10.12Z',
      key: '1g8pd9',
    },
  ],
]);

export default ThumbDownAlt;
